import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import playerSaga from './Player'
import coachSaga from './Coach'
import dashboardSaga from './Dashboard'
import sessionSaga from './Session'
import swingSaga from './Swing'
import mediaSaga from './Media'
import playerReportSaga from './PlayerReport'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    playerSaga(),
    coachSaga(),
    dashboardSaga(),
    sessionSaga(),
    swingSaga(),
    mediaSaga(),
    playerReportSaga()
  ]);
}
